import { RSAA } from "redux-api-middleware";

export const SUBLEAGUE_SET = "SUBLEAGUE_SET";
export const SUBLEAGUE_SET_LIST_OWN = "SUBLEAGUE_SET_LIST_OWN";
export const SUBLEAGUE_SET_LIST = "SUBLEAGUE_SET_LIST";
export const SUBLEAGUE_LIST_CLOSE = "SUBLEAGUE_LIST_CLOSE";
export const SUBLEAGUE_CLOSE = "SUBLEAGUE_CLOSE";

const setSubleaguesListAction = (type, entries, columns) => ({
  type: SUBLEAGUE_SET_LIST,
  payload: {
    type: type,
    entries: entries,
    columns: columns,
  },
});
const setSubleaguesListOwnAction = (own) => ({
  type: SUBLEAGUE_SET_LIST_OWN,
  payload: {
    own,
  },
});

const setSubleagueAction = (subleague, entries, columns, showMoreButton) => ({
  type: SUBLEAGUE_SET,
  payload: {
    subleague: subleague,
    entries: entries,
    columns: columns,
    showMoreButton: showMoreButton,
  },
});

export const fetchSubleaguesListOwnAction = (type, game) => (dispatch) =>
  dispatch({
    [RSAA]: {
      endpoint: `/api/v1/my/game/${game.id}/${
        type == "open" ? "open" : "prize"
      }Subleagues`,
      method: "GET",
      credentials: "same-origin",
      types: [
        "REQUEST",
        {
          type: "SUCCESS",
          payload: (action, state, res) =>
            res.json().then((json) => {
              dispatch(setSubleaguesListOwnAction(json.data));
            }),
        },
        "FAILURE",
      ],
    },
  });

export const fetchSubleaguesListAction = (type, game) => (dispatch) =>
  dispatch({
    [RSAA]: {
      endpoint: `/api/v1/game/${game.id}/${
        type == "open" ? "open" : "prize"
      }Subleagues`,
      method: "GET",
      types: [
        "REQUEST",
        {
          type: "SUCCESS",
          payload: (action, state, res) =>
            res.json().then((json) => {
              dispatch(
                setSubleaguesListAction(type, json.data, json.meta.columns)
              );
              dispatch(fetchSubleaguesListOwnAction(type, game));
            }),
        },
        "FAILURE",
      ],
    },
  });

export const fetchSubleagueEntriesAction =
  (subleague) => (dispatch, getState) => {
    let endpoint;
    if (subleague.type == "prize-subleague-entry") {
      endpoint = `/api/v1/game/${getState().games.current.id}/prizeSubleague/${
        subleague.id
      }/ranking/all`;
    } else {
      endpoint = `/api/v1/game/${getState().games.current.id}/openSubleague/${
        subleague.id
      }/ranking/all`;
    }

    dispatch({
      [RSAA]: {
        endpoint,
        method: "GET",
        types: [
          "REQUEST",
          {
            type: "SUCCESS",
            payload: (action, state, res) =>
              res.json().then((json) => {
                dispatch(
                  setSubleagueAction(
                    subleague,
                    json.data,
                    json.meta.columns,
                    json.meta.showMoreButton
                  )
                );
              }),
          },
          "FAILURE",
        ],
      },
    });
  };
